import { createSlice } from "@reduxjs/toolkit";

// Get the initial user data from localStorage (if available)
const initialUser = JSON.parse(localStorage.getItem("user")) || {
  role: null,
  access_token: "",
};

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: initialUser, // Initialize with the user data from localStorage
  },
  reducers: {
    setUser: (state, action) => {
      if (action.payload && typeof action.payload === "object") {
        state.user = { ...state.user, ...action.payload };
        localStorage.setItem("user", JSON.stringify(state.user)); // Persist user data to localStorage
      } else {
        console.error("Invalid payload for setUser:", action.payload);
      }
    },
    clearUser: (state) => {
      state.user = { role: null, access_token: "" };
      localStorage.removeItem("user"); // Clear user data from localStorage on logout
      localStorage.removeItem("selectedClassroomId");
      localStorage.removeItem("selectedTeacherId");
      localStorage.removeItem("selectedTeacherName");
    },
  },
});

// to get user data from the state using useSelector like this:
// const { user } = useSelector((state) => state.user || {});
// const user = useAuth();

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
